var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRatioLandscape = function SvgIconRatioLandscape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.8,
    height: 10.8,
    x: 1.1,
    y: 5.6,
    stroke: "#444",
    strokeWidth: 1.2,
    rx: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M12.375 16.5c-.398-1.964-1.536-3.734-3.211-4.993-1.676-1.259-3.779-1.925-5.935-1.88a10.5 10.5 0 0 0-1.854.16M20.625 12.4a13.3 13.3 0 0 0-4.274-.702c-1.84-.004-3.66.369-5.351 1.094"
  })));
};
export default SvgIconRatioLandscape;